<template>
    <div class="ag-header-with-spinner">
        {{ params.headerTitle }}
        <span v-if="loading" class="ag-header-with-spinner__spinner">
            -
            <v-icon class="spin" size="24">mdi-autorenew</v-icon>
            <span>{{ params.loadingMessage }}</span>
        </span>
        <span v-if="params.isDataLimitReached()" class="alert-banner">
            <span class="alert-banner__lock-icon">
                <icon icon-name="custom:warning" />
            </span>

            <span class="alert-banner__locked-msg">
                {{ toSentenceCase($t(params.dataLimitReachedMessage)) }}
            </span>
        </span>
    </div>
</template>

<script>
// https://www.ag-grid.com/vue-grid/component-header/
import { defineComponent } from 'vue';

export default defineComponent({
    computed: {
        loading() {
            return this.$store.state[this.params.vuexModule].loading;
        },
    },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_mixins.scss';
@import '@style/base/_variables.scss';

.spin {
    animation: spin 2s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.ag-header-with-spinner {
    padding-left: 0.7rem;

    &__spinner {
        font-size: 1.2rem;
    }

    .alert-banner {
        margin: 0;
        padding: 0;
        line-height: 2.5rem;

        &__locked {
            font-size: 1.2rem;
            font-weight: 700;
            color: $alert-banner;
        }

        &__locked-msg {
            font-size: 1.2rem;
            color: $alert-banner;
        }

        &__lock-icon {
            font-size: 2.8rem;
            svg path,
            svg text {
                fill: $alert-banner;
            }
        }

        &:deep(svg) {
            height: 2.6rem;
            width: 2.6rem;
        }
    }
}
</style>
